module.exports = __webpack_public_path__ + "static/media/Summary-white.a7a0fd10.svg";